import URLS from 'jsx/auth/constants/urls';

export const REASON_KEY = 'ineligibleReason';
export const ZIP_KEY = 'guestZip';
export const DOB_KEY = 'guestDOB';
export const STATE_KEY = 'guestState';
export const ACCEPTED_TOS_KEY = 'guestTOS';
export const VIEW_ORDER = [URLS.welcome, URLS.register];
